import React from 'react';
import { getCookie } from 'cookies-next';
import { useGetItemsQuery } from '@/stores/contentApi';
import { DEFAULT_THEME } from '@constants/constants';
import { productSpecialistQuery } from './productSpecialistQuery';
import { ProductSpecialist } from './ProductSpecialist';

type ConnectedProductSpecialistProps = {
  customTitle?: string;
};

export const ConnectedProductSpecialist = ({ customTitle }: ConnectedProductSpecialistProps) => {
  const cookieSector = getCookie('cl_sector') ?? DEFAULT_THEME;
  const sector = cookieSector.toString().toLocaleLowerCase();

  const { data }: any = useGetItemsQuery({ document: productSpecialistQuery });
  if (data) {
    const allSpecialists =
      data?.specialists?.children?.results.map((res: any) => {
        return {
          title: customTitle ? customTitle : data?.text?.title?.value || '',
          text: data?.text?.subText?.value || '',
          emailText: data?.text?.emailText?.value || '',
          fullName: res.fullName?.value || null,
          image: res.photo?.src.replace('/-/media/', '/-/jssmedia/') || null,
          sectors: res.sector.targetItems?.flatMap((item: any) => {
            return {
              name: item.name.toLowerCase(),
              phone: item.sectorPhone.value,
              email: item.sectorEmail.value
            };
          })
        };
      }) ?? [];

    const productSpecialists = allSpecialists.filter((specialist: any) =>
      specialist.sectors.some((currSector: any) => currSector.name === sector)
    );
    const specialist = productSpecialists[Math.floor(Math.random() * productSpecialists.length)];

    return <ProductSpecialist sector={sector} productSpecialist={specialist} />;
  }
  return null;
};
